<template>
  <div>
    <div v-if="field && field.options  && field.options.length > 0">
      <v-select
        v-model="internalValue"
        :items="field.options"
        :label="field.title || 'Selecciona un ítem'"
        dense
        outlined
        hide-details="auto"
        :readonly="readonly"
      />
    </div>

    <div v-else-if="field && field.type === 'boolean'">
      <v-checkbox
        v-model="internalValue"
        :label="field.title"
        dense
        outlined
        hide-details="auto"
        :readonly="readonly"
      />
    </div>

    <div v-else-if="field && field.type === 'text'">
      <v-textarea
        v-model="internalValue"
        :label="field.title"
        outlined
        hide-details="auto"
        dense
        height="300px"
        :readonly="readonly"
        />
    </div>

    <v-text-field
      v-else-if="field && field.field"
      v-model="internalValue"
      :label="field.title"
      :type="formatType(field.type)"
      outlined
      dense
      hide-details="auto"
      :readonly="readonly"
    />

    <div v-else>
      <!-- fallback UI -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnyFieldModeler',
  props: {
    value: {
        type: [String, Number, Boolean, Object, Array],
        required: true
    },
    field: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    formatType(type) {
      if (type === 'number' || type === 'integer' || type === 'float') return 'number';
      return 'text';
    }
  }
};
</script>
